'use strict';

require('styles/bvaccel-product.scss');

require('scripts/sections/testimonials');

var _Overlay = require('scripts/components/Overlay');

var _Modal = require('scripts/components/Modal');

var _Product = require('scripts/modules/Product');

var _ProductPack = require('scripts/modules/ProductPack');

// Modules

//Components
//Styles
document.addEventListener('DOMContentLoaded', function () {
  (0, _Product.init)();
  (0, _ProductPack.init)();
  (0, _Overlay.init)();
  (0, _Modal.init)();

  console.log('[BVA] Script Loaded: product.js');
});
// Sections